"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Image } from "@shared/ui/image";

import s from "./banner-photo.module.scss";

export type BannerPhotoProps = ComponentProps<"div"> & {
  photoSrc: string;
  photoAlt?: string;
  className?: string;
};

export const BannerPhoto = (props: BannerPhotoProps) => {
  const { photoSrc, photoAlt = "", className, ...restProps } = props;

  return (
    <div className={clsx(s.root, className)} {...restProps}>
      <div className={s.iconsContainer}>
        <svg
          width="560"
          height="360"
          viewBox="0 0 560 360"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="120"
            height="120"
            transform="translate(439.922)"
            fill="#7D4C8C"
          />
          <path
            d="M512.169 67.4544C512.169 70.2454 509.953 72.5085 507.219 72.5085H492.302C489.568 72.5085 487.351 70.2454 487.351 67.4544V52.1631C487.351 49.372 489.568 47.109 492.302 47.109H507.219C509.953 47.109 512.169 49.372 512.169 52.1631V67.4544ZM532.474 38.3451V38.3197H525.002C522.75 38.3197 520.925 36.4565 520.925 34.1579V29.787H520.863C520.864 29.6991 520.869 29.6124 520.869 29.5242C520.869 18.1893 511.868 9.00064 500.765 9.00064C489.662 9.00064 480.662 18.1893 480.662 29.5242C480.662 29.6251 480.668 29.7245 480.669 29.825V34.1579C480.669 36.4565 478.844 38.3197 476.592 38.3197H468.278C457.193 38.3197 448.004 47.3718 447.922 58.6881C447.839 70.0942 456.872 79.3668 468.025 79.3668V79.4167H476.592C478.844 79.4167 480.669 81.2799 480.669 83.5785V89.7924C480.668 89.893 480.662 89.9923 480.662 90.0937C480.662 101.428 489.662 110.617 500.765 110.617C511.83 110.617 520.804 101.492 520.866 90.212H520.925V83.5785C520.925 81.2799 522.75 79.4167 525.002 79.4167H532.474V79.3418C543.122 78.8205 551.599 69.8433 551.599 58.8433C551.599 47.8437 543.122 38.8664 532.474 38.3451Z"
            fill="#F4EADA"
          />
          <rect
            width="80"
            height="80"
            transform="translate(0 160)"
            fill="#FF442A"
          />
          <path
            d="M40.1192 168.002L31.3633 190.896H49.4986L40.1192 168.002Z"
            fill="#F4EADA"
          />
          <path
            d="M72.5374 199.537L49.8281 190.71V208.992L72.5374 199.537Z"
            fill="#F4EADA"
          />
          <path
            d="M8 199.537L30.7092 190.71V208.992L8 199.537Z"
            fill="#F4EADA"
          />
          <path
            d="M63.0149 177.412L40.7656 187.358L53.5891 200.286L63.0149 177.412Z"
            fill="#F4EADA"
          />
          <path
            d="M17.2695 177.409L39.5188 187.355L26.6953 200.283L17.2695 177.409Z"
            fill="#F4EADA"
          />
          <path
            d="M40.1762 232.664L48.9322 209.77H30.7969L40.1762 232.664Z"
            fill="#F4EADA"
          />
          <path
            d="M17.2695 223.26L39.5188 213.313L26.6953 200.385L17.2695 223.26Z"
            fill="#F4EADA"
          />
          <path
            d="M63.0149 223.26L40.7656 213.313L53.5891 200.385L63.0149 223.26Z"
            fill="#F4EADA"
          />
          <rect
            width="120"
            height="120"
            transform="translate(80 240)"
            fill="#E69408"
          />
          <path
            d="M155.195 300.861L190.689 285.776V315.777L155.195 300.861Z"
            fill="#54220E"
          />
          <path
            d="M140.884 285.775L126.414 249H155.192L140.884 285.775Z"
            fill="#54220E"
          />
          <path
            d="M140.723 315.776L155.192 351.584H126.414L140.723 315.776Z"
            fill="#54220E"
          />
          <path
            d="M126.412 300.693L89 315.777V285.776L126.412 300.693Z"
            fill="#54220E"
          />
          <path
            d="M150.391 310.939L186.843 326.24L165.627 347.715L150.391 310.939Z"
            fill="#54220E"
          />
          <path
            d="M150.391 289.646L165.557 253.839L186.843 274.68L150.391 289.646Z"
            fill="#54220E"
          />
          <path
            d="M129.29 310.939L114.523 347.715L93.7969 326.31L129.29 310.939Z"
            fill="#54220E"
          />
          <path
            d="M130.25 289.646L93.7969 274.748L115.013 253.839L130.25 289.646Z"
            fill="#54220E"
          />
        </svg>
      </div>

      <div className={s.photoContainer}>
        <Image
          objectFit="cover"
          src={photoSrc}
          alt={photoAlt || "banner image"}
          className={s.photo}
        />
      </div>
    </div>
  );
};

BannerPhoto.displayName = "BannerPhoto";
